import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Notification } from '@app/models/notifications/notifications.model';

@Component({
    selector: 'app-heartbeat-notification',
    templateUrl: './heartbeat.component.html',
    styleUrls: ['../notification-types.scss'],
})
export class HeartbeatNotificationComponent implements OnInit {
    @Input() notification: Notification = null;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();
    connected: boolean = false;

    constructor() {}

    ngOnInit() {
        if (
            this.notification.extra &&
            this.notification.extra.connected &&
            this.notification.extra.connected === true
        ) {
            this.connected = true;
        }
    }
}
